import { render, staticRenderFns } from "./ExpedientIncidenceForm2.vue?vue&type=template&id=15370319&scoped=true"
import script from "./ExpedientIncidenceForm2.ts?vue&type=script&lang=ts&external"
export * from "./ExpedientIncidenceForm2.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15370319",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2316091614/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15370319')) {
      api.createRecord('15370319', component.options)
    } else {
      api.reload('15370319', component.options)
    }
    module.hot.accept("./ExpedientIncidenceForm2.vue?vue&type=template&id=15370319&scoped=true", function () {
      api.rerender('15370319', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/ProcessesForms/components/P48/ExpedientIncidenceForm2/ExpedientIncidenceForm2.vue"
export default component.exports